import React from "react";
import { Link } from "react-router-dom";
import {
  Droplets,
  Instagram,
  Linkedin,
  Mail,
  MessageCircle,
} from "lucide-react";
import "../styles/Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-container">
        {/* Top Section: Grid Layout */}
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-col brand-col">
            <div className="logo-group footer-logo">
              <Droplets className="logo-icon" />
              <span className="logo-text">ChloroCast</span>
            </div>
            <p className="footer-tagline">
              Advanced water quality monitoring and predictive analytics for a
              sustainable future.
            </p>
          </div>

          {/* Quick Links Columns */}
          <div className="footer-col">
            <h4 className="footer-heading">Platform</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/dataentry">Data Entry</Link>
              </li>
              <li>
                <Link to="/prediction">Prediction Models</Link>
              </li>
              <li>
                <Link to="/admin">Admin Panel</Link>
              </li>
            </ul>
          </div>

          {/* Resources/Legal Column */}
          <div className="footer-col">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li>
                <Link to="/docs">Documentation</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms of Service</Link>
              </li>
              <li>
                <Link to="/help">Help Center</Link>
              </li>
            </ul>
          </div>

          {/* Contact Column Variable */}
          <div className="footer-col">
            <h4 className="footer-heading">Connect</h4>
            <div className="social-links">
              <a
                href="https://www.instagram.com/chlorocast"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/chlorocast/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="mailto:team.chlorocast@gmail.com" aria-label="Email">
                <Mail className="w-5 h-5" />
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=94713071131&text=%F0%9F%91%8B%20Hey%20there!%20I%27m%20interested%20in%20learning%20more%20about%20your%20project%20%22ChloroCast%22.%20Could%20you%20please%20share%20more%20details%3F"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="footer-divider" />

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} ChloroCast Systems. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
